import Modal from '@lyra/core/components/Modal'

import EnableTradingButtonRow from './EnableTradingButtonRow'

type Props = {
  onClose: () => void
}

const EnableTradingModal = ({ onClose }: Props) => {
  return (
    <Modal
      isOpen
      onChangeOpen={onClose}
      title="Enable Trading"
      subtitle="To cancel this order you must first enable trading."
      isLarge
    >
      <EnableTradingButtonRow />
    </Modal>
  )
}

export default EnableTradingModal
